import { createContext } from 'react';

/**
 * Test id context
 * @interface
 */

const testIdContext = /*#__PURE__*/createContext(undefined);
export const {
  Provider
} = testIdContext;
export default testIdContext;
//# sourceMappingURL=testIdContext.js.map